import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ParentLayout from './Layout';
import { listNotifications } from '../api/notifications';

const Notifications = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await listNotifications();
 setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err?.response?.data?.message || 'Failed to load notifications');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <ParentLayout>
      <Box>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4" fontWeight={800} color="primary.main">
              Notifications
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Alerts for lessons, assessments, and marks releases.
            </Typography>
          </Box>

          {loading && <LinearProgress />}
          {error && <Alert severity="error">{error}</Alert>}

          <Card variant="outlined">
            <CardHeader title="Latest" avatar={<NotificationsIcon color="primary" />} />
            <CardContent>
              <Stack spacing={2}>
                {items.length === 0 && (
                  <Typography variant="body2" color="text.secondary">
                    No notifications yet.
                  </Typography>
                )}
                {items.map((item) => (
                  <Card key={item._id} variant="outlined">
                    <CardContent>
                      <Stack spacing={0.5}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography fontWeight={700}>{item.title}</Typography>
                          <Chip size="small" label={item.type || 'general'} />
                        </Stack>
                        <Typography variant="body2" color="text.secondary">
                          {item.message}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {new Date(item.createdAt).toLocaleString()}
                        </Typography>
                      </Stack>
                    </CardContent>
                  </Card>
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </ParentLayout>
  );
};

export default Notifications;